/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Patient Demographics View Model for retrieval and update
 */
export interface PatientDemographicsIntegrationViewModel {
  /**
   * Patient first name, max length 50
   */
  firstName?: string | null;
  /**
   * Patient middle name, max length 50
   */
  middleName?: string | null;
  /**
   * Patient last name, max length 50
   */
  lastName?: string | null;
  /**
   * Patient suffix, max length 20
   */
  suffix?: string | null;
  /**
   * Patient SSN, max length 11
   */
  ssn?: string | null;
  /**
   * Patient Medical Record Number
   */
  medicalRecordNumber?: string | null;
  /**
   * Patient Date of Birth
   */
  birthDate?: string | null;
  /**
   * Patient Gender. (M)ale, (F)emale, (O)ther are valid values.
   */
  gender?: string | null;
  /**
   * Patient Address Line 1, max length 100
   */
  address1?: string | null;
  /**
   * Patient Address Line 2, max length 100
   */
  address2?: string | null;
  /**
   * Patient City, max length 50
   */
  city?: string | null;
  /**
   * Patient State Code, must be a valid US State
   */
  stateCode?: string | null;
  /**
   * Patient Zipcode, max length 10
   */
  zip?: string | null;
  /**
   * Patient country code
   */
  countryCode?: string | null;
  /**
   * Patient home phone number, max length 30
   */
  homePhone?: string | null;
  /**
   * Patient work phone number, max length 30
   */
  workPhone?: string | null;
  /**
   * Patient mobile phone number, max length 30
   */
  mobilePhone?: string | null;
  /**
   * Patient Email Address, max length 100
   */
  email?: string | null;
  /**
   * Option to use alternate mailing address
   */
  useAlternateMailingAddress?: boolean;
  /**
   * Patient alternate name, max length 100
   */
  alternateName?: string | null;
  /**
   * Patient alternate address line 1, max length 100
   */
  alternateAddress1?: string | null;
  /**
   * Patient alternate address line 2, max length 100
   */
  alternateAddress2?: string | null;
  /**
   * Patient alternate address city, max length 50
   */
  alternateCity?: string | null;
  /**
   * Patient alternate address state code, must be a valid US state
   */
  alternateStateCode?: string | null;
  /**
   * Patient alternate address zipcode, max length 10
   */
  alternateZip?: string | null;
  /**
   * Patient alternate address country code, max length 20
   */
  alternateCountryCode?: string | null;
  /**
   * Patient Employer Name, max length 100
   */
  employerName?: string | null;
  /**
   * Patient Employer address line 1, max length 100
   */
  employerAddress1?: string | null;
  /**
   * Patient Employer address line 2, max length 100
   */
  employerAddress2?: string | null;
  /**
   * Patient Employer city, max length 50
   */
  employerCity?: string | null;
  /**
   * Patient Employer state code, must be a valid US state code
   */
  employerStateCode?: string | null;
  /**
   * Patient Employer zipcode, max length 10
   */
  employerZip?: string | null;
  /**
   * Patient Employer country code, max length 20
   */
  employerCountryCode?: string | null;
  /**
   * Patient Employer phone number, max length 30
   */
  employerPhone?: string | null;
}
